import { cva } from 'class-variance-authority';
const gapValues = [0, 1, 2, 3, 4, 5, 6, 8, 10, 12];
const spaceYClasses = {
    0: '',
    1: 'space-y-1',
    2: 'space-y-2',
    3: 'space-y-3',
    4: 'space-y-4',
    5: 'space-y-5',
    6: 'space-y-6',
    8: 'space-y-8',
    10: 'space-y-10',
    12: 'space-y-12',
};
const spaceXClasses = {
    0: '',
    1: 'space-x-1',
    2: 'space-x-2',
    3: 'space-x-3',
    4: 'space-x-4',
    5: 'space-x-5',
    6: 'space-x-6',
    8: 'space-x-8',
    10: 'space-x-10',
    12: 'space-x-12',
};
const wrapMarginClasses = {
    0: '',
    1: '-m-0.5 [&>*]:m-0.5',
    2: '-m-1 [&>*]:m-1',
    3: '-m-1.5 [&>*]:m-1.5',
    4: '-m-2 [&>*]:m-2',
    5: '-m-2.5 [&>*]:m-2.5',
    6: '-m-3 [&>*]:m-3',
    8: '-m-4 [&>*]:m-4',
    10: '-m-5 [&>*]:m-5',
    12: '-m-6 [&>*]:m-6',
};
const columnGapCompoundVariants = gapValues.flatMap((gap) => [
    { wrap: false, direction: 'column', gap, class: spaceYClasses[gap] },
    {
        wrap: false,
        direction: 'column-reverse',
        gap,
        class: gap === 0 ? '' : `${spaceYClasses[gap]} space-y-reverse`,
    },
]);
const rowGapCompoundVariants = gapValues.flatMap((gap) => [
    { wrap: false, direction: 'row', gap, class: spaceXClasses[gap] },
    {
        wrap: false,
        direction: 'row-reverse',
        gap,
        class: gap === 0 ? '' : `${spaceXClasses[gap]} space-x-reverse`,
    },
]);
const wrapGapCompoundVariants = gapValues.map((gap) => ({
    wrap: true,
    gap,
    class: wrapMarginClasses[gap],
}));
const stackDirectionMap = {
    row: 'flex-row',
    column: 'flex-col',
    'row-reverse': 'flex-row-reverse',
    'column-reverse': 'flex-col-reverse',
};
const stackAlignMap = {
    start: 'items-start',
    center: 'items-center',
    end: 'items-end',
    stretch: 'items-stretch',
    baseline: 'items-baseline',
};
const stackJustifyMap = {
    start: 'justify-start',
    center: 'justify-center',
    end: 'justify-end',
    between: 'justify-between',
    around: 'justify-around',
    evenly: 'justify-evenly',
};
const stackWrapMap = {
    true: 'flex-wrap',
    false: 'flex-nowrap',
};
const stackGapMap = {
    0: '',
    1: '',
    2: '',
    3: '',
    4: '',
    5: '',
    6: '',
    8: '',
    10: '',
    12: '',
};
/** lab·문서용. compoundVariants(gap 해석)는 `stackVariants`에만 있다. */
export const stackCva = {
    variants: {
        direction: stackDirectionMap,
        align: stackAlignMap,
        justify: stackJustifyMap,
        wrap: stackWrapMap,
        gap: stackGapMap,
    },
    defaultVariants: {
        direction: 'column',
        align: 'stretch',
        justify: 'start',
        wrap: false,
        gap: 2,
    },
};
export const stackDirectionKeys = Object.keys(stackCva.variants.direction);
export const stackAlignKeys = Object.keys(stackCva.variants.align);
export const stackJustifyKeys = Object.keys(stackCva.variants.justify);
export const stackGapKeys = Object.keys(stackCva.variants.gap).map(Number);
export const stackVariants = cva('flex', {
    variants: stackCva.variants,
    compoundVariants: [
        ...columnGapCompoundVariants,
        ...rowGapCompoundVariants,
        ...wrapGapCompoundVariants,
    ],
    defaultVariants: stackCva.defaultVariants,
});
//# sourceMappingURL=stack.cva.js.map